import { useRouter } from "next/router";
import { UnreadNotificationButton } from "@/modules/instance/UnreadNotificationButton";
import { RolesEditorButton } from "./RolesEditorButton";

export const GlobalFloatingActions = () => {
  const router = useRouter();

  // Don't render on the login page — the API calls inside these
  // components would get 401s and trigger a redirect loop.
  if (router.pathname === "/login") return null;

  const currentInstanceId =
    router.pathname === "/instance/[id]" && typeof router.query.id === "string"
      ? router.query.id
      : "";

  return (
    <div className="fixed bottom-24 right-4 z-20 flex flex-col-reverse items-end gap-3">
      <UnreadNotificationButton currentInstanceId={currentInstanceId} />
      <RolesEditorButton />
    </div>
  );
};
